import type {EstablishedAhpResumptionAttempt} from '@github-ui/ahp-session-client/contracts'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'
import {useCallback, useSyncExternalStore} from 'react'

function getTimeoutError(signal: AbortSignal | undefined): Error | undefined {
  if (!signal?.aborted || !(signal.reason instanceof Error)) return undefined
  return 'failure' in signal.reason &&
    (signal.reason as {failure?: {kind?: string}}).failure?.kind === 'resumption-timeout'
    ? signal.reason
    : undefined
}

export function useEstablishedAhpResumptionAttemptError(
  attempt: EstablishedAhpResumptionAttempt | undefined,
): Error | undefined {
  const {isBrowser} = useRuntimeEnvironment()
  const signal = isBrowser ? attempt?.signal : undefined
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      signal?.addEventListener('abort', onStoreChange)
      return () => signal?.removeEventListener('abort', onStoreChange)
    },
    [signal],
  )
  const getSnapshot = useCallback(() => getTimeoutError(signal), [signal])

  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
